import dayjs from 'dayjs';

export default () => {
  const getAge = (birthDate: string): number => {
    if (!birthDate) return 0;
    const years = dayjs().diff(dayjs(birthDate, 'YYYY-MM-DD'), 'year');
    const months = dayjs().diff(dayjs(birthDate, 'YYYY-MM-DD'), 'month');
    if (years >= 1) return years;
    return months === 0 ? 0.01 : months / 100;
  };

  const getPregnantSince = (pregnancyDate: string | null): number => {
    if (!pregnancyDate) return 0;
    const diffD = dayjs().diff(dayjs(pregnancyDate, 'YYYY-MM-DD'), 'day');
    if (diffD < 0) return -1;
    if (diffD < 16) return 0.5;
    const diffM = diffD / 30;
    const smaller05 = (diffD / 30) % 1 <= 0.5;
    return smaller05 ? parseInt(diffM.toString()) : parseInt(diffM.toString()) + 0.5;
  };

  const getPregnancyDate = (pregnantSince: number | string): string | null => {
    const mesI = parseInt(pregnantSince.toString());
    const mesF = parseFloat(pregnantSince.toString());
    if (pregnantSince === 0) return null;
    if (mesF % 1 === 0.5) {
      return dayjs().subtract(mesI, 'month').subtract(15, 'day').format('YYYY-MM-DD');
    }
    return dayjs().subtract(mesI, 'month').format('YYYY-MM-DD');
  };

  const getBirthDate = (age: number | string): string => {
    if (Number(age) >= 1) {
      return dayjs().subtract(Number(age), 'year').format('YYYY-MM-DD');
    }
    return dayjs()
      .subtract(parseFloat(age.toString()) * 100, 'month')
      .format('YYYY-MM-DD');
  };

  const getFemale = (gender: string | number): boolean => gender === 'female';

  return { getAge, getPregnantSince, getPregnancyDate, getBirthDate, getFemale };
};
